module.exports = __webpack_public_path__ + "media/images/emoticons/camera-69c2e1698ba0555b2bcabf1eaaff2fbb.gif";